<div class="hidden lg:flex flex-col gap-3 w-28">
  <button
    routerLink="/registration-form"
    class="shine-button shadow-custom cursor-pointer bg-gradient-primary w-full px-5 py-6 flex flex-col items-center justify-center gap-3 rounded-xl">
    <app-icon name="material-symbols:arrow-outward-rounded" class="size-7! text-white" />
    <span class="text-base sb-aggro text-white">사전 등록</span>
  </button>

  <button
    routerLink="/booth-application-form"
    class="shadow-custom cursor-pointer bg-white w-full px-5 py-6 flex flex-col items-center justify-center gap-3 rounded-xl">
    <app-icon name="mdi:file-document-edit-outline" class="size-7! text-zinc-800" />
    <span class="text-base sb-aggro text-zinc-800">참가 신청</span>
  </button>

  <button
    routerLink="/inquiry/form"
    class="shadow-custom cursor-pointer bg-white w-full px-5 py-6 flex flex-col items-center justify-center gap-3 rounded-xl">
    <app-icon name="mdi:square-edit-outline" class="size-7! text-zinc-800" />
    <span class="text-base sb-aggro text-zinc-800">제휴 문의</span>
  </button>

  <a
    href="https://www.instagram.com/best.expo/#"
    target="_blank"
    rel="noopener noreferrer"
    class="shadow-custom cursor-pointer bg-white w-full px-5 py-6 flex flex-col items-center justify-center gap-3 rounded-xl">
    <img src="/home/insta.svg" alt="instagram icon" class="size-7! object-contain" />
    <span class="text-base sb-aggro text-zinc-800 whitespace-nowrap">인스타그램</span>
  </a>

  <a
    href="https://www.youtube.com/@bestexpo"
    target="_blank"
    rel="noopener noreferrer"
    class="shadow-custom cursor-pointer bg-white w-full px-5 py-6 flex flex-col items-center justify-center gap-3 rounded-xl">
    <img src="/home/youtube.svg" alt="youtube icon" class="size-7! object-contain" />
    <span class="text-base sb-aggro text-zinc-800 whitespace-nowrap">유튜브</span>
  </a>
</div>

<!-- 모바일 버전 (토글 버튼) -->
<div class="lg:hidden">
  <button
    (click)="toggleMenu()"
    class="toggle-button shine-button shadow-custom cursor-pointer bg-gradient-primary w-14 h-14 flex items-center justify-center rounded-full"
    [class.active]="isMenuOpen">
    <app-icon
      [name]="isMenuOpen ? 'mdi:close' : 'mdi:menu'"
      class="size-6! text-white transition-transform duration-300"
      [class.rotate-90]="isMenuOpen" />
  </button>

  <div class="mobile-menu" [class.open]="isMenuOpen">
    <a
      href="tel:1522-1564"
      (click)="closeMenu()"
      class="menu-item shine-button shadow-custom cursor-pointer bg-gradient-primary px-4 h-11 flex items-center justify-center gap-2 rounded-full"
      style="animation-delay: 0.05s">
      <app-icon name="material-symbols:call" class="size-5! text-white shrink-0" />
      <span class="text-sm sb-aggro text-white whitespace-nowrap">전화 연결</span>
    </a>

    <a
      href="https://www.instagram.com/best.expo/#"
      target="_blank"
      rel="noopener noreferrer"
      (click)="closeMenu()"
      class="menu-item shadow-custom cursor-pointer bg-white px-4 h-11 flex items-center justify-center gap-2 rounded-full"
      style="animation-delay: 0.1s">
      <img src="/home/insta.svg" alt="instagram icon" class="size-5! shrink-0" />
      <span class="text-sm sb-aggro text-zinc-800 whitespace-nowrap">인스타</span>
    </a>

    <a
      href="https://www.youtube.com/@bestexpo"
      target="_blank"
      rel="noopener noreferrer"
      (click)="closeMenu()"
      class="menu-item shadow-custom cursor-pointer bg-white px-4 h-11 flex items-center justify-center gap-2 rounded-full"
      style="animation-delay: 0.15s">
      <img src="/home/youtube.svg" alt="youtube icon" class="size-5! shrink-0" />
      <span class="text-sm sb-aggro text-zinc-800 whitespace-nowrap">유튜브</span>
    </a>
  </div>
</div>
